import {
  Component
} from "react";
import AppUI from '../../../../dictionaries/AppUI.dic';
import {
  NOT,
  YES
} from '../../../../lib/Boolean.lib';
import Core from "../../../../lib/Core";
import {
  formatDateTime24hPT
} from '../../../../lib/Date.lib';
import Definition, {
  ACCOUNT_ACTION__EDIT_EMPLOYER,
  EMPLOYER_SUBMISSION_METHOD__ATS,
  EMP_MSG_TYPE__REMINDER_ID,
  ID__ATS_TYPE__ASHBY_API,
  ID__ATS_TYPE__GH_HARVEST,
  ID__ATS_TYPE__GH_INGESTION,
  ID__ATS_TYPE__LEVER_API
} from "../../../../lib/Definition";
import {
  getEmployerAccounts
} from '../../../../lib/Employer';
import {
  Obj
} from '../../../../lib/Object.lib';
import {
  trim
} from '../../../../lib/String.lib';
import encodeBasicAuthCredentials from '../../../../lib/String/encodeBasicAuthCredentials.fun';
import {
  MATERIAL_ICON_NAME__EYE
} from '../../../../lib/constants/MaterialIconName.dic';
import {
  mapAccount
} from "../../../../lib/models/account";
import Ashby from '../../../../lib/services/ATS/Ashby.lib';
import getAtsContextProperty from '../../../../lib/services/ATS/getAtsContextProperty.fun';
import getAtsContextUpdated from '../../../../lib/services/ATS/getAtsContextUpdated.fun';
import {
  COLLECTION__JOBS
} from '../../../../lib/services/BE/loopback.api';
import InternalSubmissionInstructions from '../../../Employers/Edit/Forms/InternalSubmissionInstructions';
import EmployerUI from '../../../Employers/EmployerUI.dic';
import Chips from "../../../Forms/Chips";
import {
  EmailsListClass
} from "../../../Forms/EmailsList";
import StepHeader from '../../../Forms/StepHeader';
import Box from '../../../Layout/Wrappers/Box';
import Checkbox from '../../../Layout/Wrappers/Checkbox';
import Col from "../../../Layout/Wrappers/Col";
import DatePicker from '../../../Layout/Wrappers/DatePicker';
import Fieldset from '../../../Layout/Wrappers/Fieldset';
import IconButton from '../../../Layout/Wrappers/IconButton';
import InputNumber from '../../../Layout/Wrappers/InputNumber';
import Menu from '../../../Layout/Wrappers/Menu';
import {
  ErrorMessage,
  LoadingMessage
} from '../../../Layout/Wrappers/Message';
import Once from '../../../Layout/Wrappers/Once';
import RadioGroup from '../../../Layout/Wrappers/RadioGroup';
import RichTextBox from "../../../Layout/Wrappers/RichTextBox";
import Row from "../../../Layout/Wrappers/Row";
import TaggedValue from '../../../Layout/Wrappers/TaggedValue';
import TextField from '../../../Layout/Wrappers/TextField';
import {
  Label
} from '../../../Layout/Wrappers/Typography';
import {
  PrescreenQuestionsEdit
} from '../../../PrescreenQuestions/PrescreenQuestionsSection';
import {
  JOB_SECTION__INTERVIEW_PROCESSES,
  JOB_SECTION__PUBLIC_NOTES,
  JOB_SECTION__SUMMARY,
  openJobView
} from '../../Card/JobDetails';
import FieldsetEngagementFeedbackReasons from '../Forms/FieldsetEngagementFeedbackReasons';

class Process extends Component {
  render() {
    const JobEditController = this.props.parent;

    let {
      state = {}
    } = JobEditController;
    const {
      employer = {},
      submissionMethods = [],
      __accounts = {}
    } = state;
    const {
      atsTypeId
    } = employer;

    const API_KEY = encodeBasicAuthCredentials({
      username: getAtsContextProperty({
        entity: employer,
        atsTypeId: ID__ATS_TYPE__ASHBY_API,
        property: 'apiKey'
      }).trim()
    });

    const YES__ATS__LEVER_API = (
      atsTypeId === ID__ATS_TYPE__LEVER_API
    );

    const YES__ATS__ASHBY_API = (
      atsTypeId === ID__ATS_TYPE__ASHBY_API
    )

    const YES__ATS_AVAILABLE = (
      submissionMethods.includes(
        EMPLOYER_SUBMISSION_METHOD__ATS
      ) &&
      [
        ID__ATS_TYPE__GH_HARVEST,
        ID__ATS_TYPE__GH_INGESTION,
        ID__ATS_TYPE__LEVER_API,
        ID__ATS_TYPE__ASHBY_API
      ].includes(atsTypeId)
    );

    const ID__ATS__JOB = getAtsContextProperty({
      collection: COLLECTION__JOBS,
      entity: JobEditController.state,
      atsTypeId,
      property: 'jobId'
    });

    const ID__ATS__POST = getAtsContextProperty({
      entity: JobEditController.state,
      atsTypeId,
      property: 'postId'
    });

    const ATS_JOB = Obj(state.__atsJob);
    const VALUE__ATS__JOB__TITLE = trim(ATS_JOB.title);
    const VALUE__ATS__JOB__STATUS = trim(ATS_JOB.status);
    const VALUE__ATS__JOB__UPDATED_AT = formatDateTime24hPT(ATS_JOB.updatedAt);
    const YES__BUSY__ATS_JOB = YES(state.__atsJobBusy);
    const YES__ERROR__ATS_JOB = YES(state.__atsJobError);

    const updateState = async (update) => {
      return new Promise((resolve) => {
        JobEditController.setState(
          (prevState) => ({ ...prevState, ...update }),
          resolve
        );
      });
    }

    const fetchAtsJob = async ({ jobId }) => {
      let atsJob = {};
      if (jobId && YES__ATS__ASHBY_API) {
        await updateState({ __atsJobBusy: true, __atsJobError: false });
        atsJob = Obj(
          await Ashby.getJob({
            id: jobId,
            apiKey: API_KEY
          })
        );
      }
      await updateState({
        __atsJob: atsJob,
        __atsJobBusy: false,
        __atsJobError: jobId && YES__ATS__ASHBY_API && NOT(atsJob.id)
      });
      return atsJob;
    }

    const fetchAccounts = async () => {
      __accounts.error = false;
      __accounts.fetching = true;
      __accounts.fetched = false;
      await updateState({ __accounts });
      __accounts.list = await getEmployerAccounts({ employerId: employer.id }).catch(Core.showError);
      if (Array.isArray(__accounts.list)) {
        __accounts.error = false;
        __accounts.fetching = false;
        __accounts.fetched = true;
      }
      else {
        __accounts.error = true;
        __accounts.fetching = false;
        __accounts.fetched = false;
      }
      employer.__accounts = __accounts;
      await updateState({ __accounts, employer });
    }

    if (state.id && !__accounts.error && !__accounts.fetching && !__accounts.fetched) {
      fetchAccounts();
    }

    return (
      <Box column flex1>

        <StepHeader {...this.props} />

        <Box row
          className='flex-align-left-top'
        >
          <Fieldset
            wrapperProps={{ style: { marginTop: '1.25rem' } }}
          >
            <Chips
              name="employerSubmissionMethod"
              label={<label>Submission Method(s)</label>}
              sub="Please select all the submission methods your are interested in"
              values={JobEditController.state.submissionMethods || []}
              onChange={(submissionMethods) => {
                JobEditController.setState({ submissionMethods });
              }}
            />
          </Fieldset>
          <Fieldset
            title='Submission Method (obsolete)'
          >
            <Menu dropdown
              name="submissionMethod"
              value={parseInt(JobEditController.state.submissionMethod)}
              onChange={(submissionMethod) =>
                JobEditController.setState({ submissionMethod })
              }
              options={Definition.get("employerSubmissionMethod")}
            />
          </Fieldset>
        </Box>

        <Box row
          className='flex-align-left-top'
        >
          <Fieldset
            acl={YES__ATS__LEVER_API}
            title={
              <Label className='tt-none'>
                ATS Posting ID
              </Label>
            }
            subtitle='The ID of the job posting you want to apply to'
          >
            <TextField
              type='text'
              value={ID__ATS__POST}
              onChange={(event, postId) => JobEditController.setState(
                getAtsContextUpdated({
                  entity: JobEditController.state,
                  atsTypeId,
                  update: { postId }
                })
              )}
              fullWidth
            />
          </Fieldset>
          <Fieldset
            acl={YES__ATS_AVAILABLE}
            title={
              <Label className='tt-none'>
                ATS Job ID
              </Label>
            }
            subtitle='The Job ID for creating the application'
          >
            <TextField
              value={ID__ATS__JOB}
              onChange={(event, jobId) => {
                JobEditController.setState(
                  getAtsContextUpdated({
                    entity: JobEditController.state,
                    atsTypeId,
                    update: { jobId }
                  })
                );
                return fetchAtsJob({ jobId });
              }}
            />
          </Fieldset>
          <Fieldset
            title={YES(ID__ATS__JOB) &&
              <Label className='tt-none'>
                ATS Job Info
              </Label>
            }
          >
            <Box column
              acl={YES__ATS__ASHBY_API}
              className='pr-1'
            >
              <Once
                acl={YES(ID__ATS__JOB)}
                promise={async () => fetchAtsJob({ jobId: ID__ATS__JOB })}
              />
              <LoadingMessage
                show={YES__BUSY__ATS_JOB}
                className='m-0'
              >
                Fetching information from ATS
              </LoadingMessage>
              <ErrorMessage
                show={YES__ERROR__ATS_JOB}
                className='m-0'
              >
                Error fetching information from ATS
              </ErrorMessage>
              <Box column
                acl={YES__ATS_AVAILABLE && YES(ATS_JOB.id)}
              >
                <TaggedValue
                  tag='Title'
                  value={VALUE__ATS__JOB__TITLE}
                />
                <TaggedValue
                  tag='Status'
                  value={VALUE__ATS__JOB__STATUS}
                />
                <TaggedValue
                  tag='Updated at'
                  value={VALUE__ATS__JOB__UPDATED_AT}
                />
              </Box>
            </Box>
          </Fieldset>
        </Box>

        <FieldsetEngagementFeedbackReasons />

        <InternalSubmissionInstructions
          title={
            <>
              Employer:
              &nbsp;
              {EmployerUI.internalSubmissionInstructions.title}
            </>
          }
          entity={JobEditController.state.employer}
          onChange={
            async (update) => new Promise((resolve) =>
              JobEditController.setState({
                employer: Object.assign(
                  JobEditController.state.employer,
                  update
                )
              }, resolve)
            )
          }
          autoSave={false}
        />

        <InternalSubmissionInstructions
          title={
            <>
              Job:
              &nbsp;
              {EmployerUI.internalSubmissionInstructions.title}
            </>
          }
          entity={JobEditController.state}
          onChange={
            async (update) => new Promise((resolve) =>
              JobEditController.setState(
                update,
                resolve
              )
            )
          }
          autoSave={false}
        />

        <PrescreenQuestionsEdit
          Controller={JobEditController}
          className='mt-3'
        />

        <Fieldset
          title={
            <>Employer Generic Interview Process</>
          }
          subtitle=''
          info={AppUI.publicInfo.tooltip}
          infoIconName={MATERIAL_ICON_NAME__EYE}
          infoProps={{
            onClick: openJobView({
              jobId: JobEditController.state.id,
              sectionName: JOB_SECTION__INTERVIEW_PROCESSES
            })
          }}
        >
          <RichTextBox
            name="interviewProcess"
            value={JobEditController.state.employer.interviewProcess}
            disabled
          />
        </Fieldset>

        <Fieldset
          title={
            <>Job Specific Interview Process</>
          }
          subtitle={
            <i>Employer's generic interview process is shown above. The job-specific interview process is detailed here</i>
          }
          info={AppUI.publicInfo.tooltip}
          infoIconName={MATERIAL_ICON_NAME__EYE}
          infoProps={{
            onClick: openJobView({
              jobId: JobEditController.state.id,
              sectionName: JOB_SECTION__INTERVIEW_PROCESSES
            })
          }}
        >
          <RichTextBox
            name="jobInterviewProcess"
            value={JobEditController.state.jobInterviewProcess}
            onChange={jobInterviewProcess => {
              JobEditController.setState({
                jobInterviewProcess,
              });
            }}
          />
        </Fieldset>

        <Fieldset
          title='Public Notes'
          subtitle=''
          info={AppUI.publicInfo.tooltip}
          infoIconName={MATERIAL_ICON_NAME__EYE}
          infoProps={{
            onClick: openJobView({
              jobId: JobEditController.state.id,
              sectionName: JOB_SECTION__PUBLIC_NOTES
            })
          }}
        >
          <RichTextBox
            name="publicNotes"
            value={JobEditController.state.publicNotes}
            onChange={publicNotes => {
              JobEditController.setState({
                publicNotes,
              });
            }}
          />
        </Fieldset>

        <Box>
          <EmailsListClass
            name={'jobs_forms_process__employer_contacts'}
            title={<Label className='tt-unset tt-none'>Employer contacts</Label>}
            subtitle={
              <>
                Email notification subscription for {JobEditController.state.employer?.name}
              </>
            }
            model={employer}
            onSave={update => {
              JobEditController.setState({ employer: { ...employer, ...update }, saveEmployer: true });
            }}
            messageTypeTags={Definition.get('employerMessageType').filter(({ id }) => id === EMP_MSG_TYPE__REMINDER_ID)}
            actionBar={
              <IconButton icon='open_in_new'
                title='Edit Employer'
                acl={Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER })}
                onClick={event => Core.openPopUp(`/#/employer/edit/${JobEditController.state.employer?.id}`, 1600)}
              />
            }
          />
          <EmailsListClass
            name={'jobs_forms_process__job_contacts'}
            title={<Label className='tt-unset tt-none'>Job contacts</Label>}
            subtitle={'Email notification subscription'}
            model={JobEditController.state}
            onSave={update => JobEditController.setState(update)}
            messageTypeTags={Definition.get('employerMessageType')}
            disabledExclude
          />
        </Box>

        <Box column
          className='mt-3 px-1'
        >
          <Box column
            className="outlined rounded-sm bg-green-lighter p-1"
          >

            <Row>
              <Col>
                <h4>For 10 by 10 use only</h4>
              </Col>
            </Row>

            <Row>
              <Fieldset
                title={
                  <>Current State</>
                }
                info={AppUI.publicInfo.tooltip}
                infoIconName={MATERIAL_ICON_NAME__EYE}
                infoProps={{
                  onClick: openJobView({
                    jobId: JobEditController.state.id,
                    sectionName: JOB_SECTION__SUMMARY
                  })
                }}
                fullWidth={false}
              >
                <RadioGroup column
                  name="current_state"
                  options={Definition.get("state")
                    .filter((tag) =>
                      Core.isAdminOrCoordinator()
                        ? true
                        : Definition.test("state", tag.id, /draft/)
                    )}
                  value={JobEditController.state.state}
                  onChange={(event, state) => JobEditController.setState({ state })}
                />
              </Fieldset>
              <Fieldset
                title={
                  <>Flags</>
                }
                fullWidth={false}
              >
                <Col>
                  {Definition.get("flags").map((tag) => (
                    <Checkbox
                      key={tag.id}
                      label={tag.label}
                      style={{ margin: "16px 0" }}
                      checked={!!~JobEditController.state.flags.indexOf(tag.id)}
                      onCheck={(ev, checked) => {
                        JobEditController.setState((state) => {
                          state = { flags: JobEditController.state.flags };
                          if (checked) {
                            if (!state.flags.find((id) => id === tag.id)) {
                              state.flags.push(tag.id);
                            }
                          } else {
                            state.flags = state.flags.filter((id) => id !== tag.id);
                          }
                          Core.log({ state });
                          return state;
                        });
                      }}
                    />
                  ))}
                </Col>
              </Fieldset>
            </Row>

            <Row>
              <Fieldset
                title={
                  <>Placement Fee</>
                }
              >
                <InputNumber
                  name="placementFee"
                  max={100}
                  maxLength={5}
                  value={JobEditController.state.placementFee}
                  onChange={(placementFee) =>
                    JobEditController.setState({
                      placementFee: Number(
                        placementFee > 100
                          ? 100
                          : String(placementFee).slice(0, 5)
                      ),
                    })
                  }
                  units='%'
                />
              </Fieldset>
              <Fieldset
                title={
                  <>Guarantee</>
                }
              >
                <InputNumber
                  name="guarantee"
                  maxLength={3}
                  value={JobEditController.state.guarantee}
                  onChange={(guarantee) =>
                    JobEditController.setState({
                      guarantee:
                        guarantee > 999
                          ? 999
                          : String(Math.round(guarantee)).slice(0, 3),
                    })
                  }
                  units='days'
                />
              </Fieldset>
            </Row>

            <Row className='mt-3'>
              <Col fullWidth>
                <label>Additional Contract Information</label>
                <TextField
                  name="additionalContractInfo"
                  type="text"
                  rows={1}
                  rowsMax={3}
                  value={JobEditController.state.additionalContractInfo}
                  onChange={(ev, additionalContractInfo) =>
                    JobEditController.setState({
                      additionalContractInfo,
                    })
                  }
                />
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col fullWidth>
                <label>Default Resume Submission Template</label>
                <Menu
                  name="emailTemplates"
                  value={JobEditController.state.resumeSubmissionEmailTemplateId}
                  onChange={(resumeSubmissionEmailTemplateId) => {
                    JobEditController.setState({ resumeSubmissionEmailTemplateId });
                  }}
                  fullWidth
                  options={JobEditController.state.emailTemplates}
                />
              </Col>
            </Row>
            <Row className="edit-account-list-row">
              {!!JobEditController.state.employer &&
                JobEditController.state.employer.employerSourceList && (
                  <Col className="edit-account-list-col rounded">
                    <label>Employer Source List</label>
                    {JobEditController.state.employer.employerSourceList.map((item) => {
                      item = mapAccount(item);
                      return (
                        <li key={item.id}>{item._name || <i>&mdash;</i>}</li>
                      );
                    })}
                  </Col>
                )}
              {!!JobEditController.state.jobSourceList && (
                <Col className="edit-account-list-col rounded">
                  <label>Job Source List</label>
                  {JobEditController.state.jobSourceList.map((item) => {
                    item = mapAccount(item);
                    return <li key={item.id}>{item._name || <i>&mdash;</i>}</li>;
                  })}
                </Col>
              )}
            </Row>
            <Row className='mt-3'>
              <Col fullWidth>
                <label>Private Notes</label>
                <RichTextBox
                  name="privateNotes"
                  value={JobEditController.state.privateNotes}
                  onChange={privateNotes => {
                    JobEditController.setState({
                      privateNotes,
                    });
                  }}
                />
              </Col>
            </Row>
          </Box>
        </Box>

        <Row className='mt-3'>
          <Col>
            <label>Creation Date</label>
            <DatePicker
              name="createdAt"
              value={
                JobEditController.state.createdAt ? new Date(JobEditController.state.createdAt) : null
              }
              onChange={(createdAt) => {
                JobEditController.setState({ createdAt: createdAt.toISOString() });
              }}
            />
          </Col>
          <Col>
            <label>Last Update</label>
            <DatePicker
              name="updatedAt"
              value={
                JobEditController.state.updatedAt ? new Date(JobEditController.state.updatedAt) : null
              }
              onChange={(updatedAt) => {
                JobEditController.setState({ updatedAt: updatedAt.toISOString() });
              }}
            />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <label>Closed Date</label>
            <DatePicker
              name="closeDate"
              value={
                JobEditController.state.closeDate ? new Date(JobEditController.state.closeDate) : null
              }
              onChange={(closeDate) => {
                JobEditController.setState({ closeDate: closeDate.toISOString() });
              }}
            />
          </Col>
        </Row>
      </Box >
    );
  }
}

export default Process;
